// extracted by mini-css-extract-plugin
export var borderRadius = "_4f-4";
export var large = "_4f-3";
export var logoContainer = "_4f-0";
export var nameLogo = "_4f-2";
export var small = "_4f-1";